import { Col, Row } from "@amzn/stencil-react-components/layout";
import { H2, Text, TextVariant } from "@amzn/stencil-react-components/text";
import React, { FC } from "react";
import { BorderedCard } from "@/common/components/BorderedCard/bordered-card";
import { DeviceThumbnail } from "@/common/components/DeviceThumbnail/device-thumbnail";
import { getString } from "@/common/uistringlabels/ui-string-utils";
import type { OrderedItem } from "@/pages/OrderTracking/order-tracking.types";

const DETAILS_SEPARATOR = " · ";
const THUMBNAIL_IMAGE_INSET = 6;

export interface OrderedItemsProps {
  item: OrderedItem;
}

export const OrderedItems: FC<OrderedItemsProps> = ({ item }) => (
  <BorderedCard
    borderRadius="200"
    padding={["S300", "S400"]}
    gridGap="S300"
    dataTestId="ordered-items"
  >
    <H2 variant={TextVariant.HeadingXS} color="color.text.primary">
      {getString("orderTracking.items.title")}
    </H2>
    <Row gridGap="S300" alignItems="center">
      <DeviceThumbnail
        imageSrc={item.imageUrl ?? ""}
        altText={item.name}
        imageInset={THUMBNAIL_IMAGE_INSET}
        dataTestId="ordered-item-image"
      />
      <Col gridGap="S100" style={{ minWidth: 0 }}>
        <Text variant={TextVariant.BodyMDInteractive} color="color.text.primary">
          {item.name}
        </Text>
        {item.details.length > 0 && (
          <Text
            variant={TextVariant.BodySM}
            color="color.text.secondary"
            data-testid="ordered-item-details"
          >
            {item.details.join(DETAILS_SEPARATOR)}
          </Text>
        )}
      </Col>
    </Row>
  </BorderedCard>
);
